export function toClient(row) {
  if (!row || typeof row !== "object" || Array.isArray(row)) return row;
  const details = row.details && typeof row.details === "object" ? toClient(row.details) : {};
  const out = { ...details };
  Object.entries(row).forEach(([key, value]) => {
    if (key === "details") return;
    const camel = key.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
    out[camel] = value;
  });
  if (row.id) {
    out.id = row.id;
    out._id = row.id;
  }
  return out;
}

export function toRows(data) {
  return (data || []).map(toClient);
}

export function fail(message, status = 400) {
  const error = new Error(message);
  error.response = { status, data: { message } };
  error.userMessage = message;
  return error;
}

export function assertNoError(error) {
  if (!error) return;
  throw fail(error.message || "Request failed", error.code === "42501" ? 403 : 400);
}

export function metaFor(page, limit, total) {
  const safeLimit = Math.max(1, Number(limit) || 10);
  const safePage = Math.max(1, Number(page) || 1);
  return {
    page: safePage,
    limit: safeLimit,
    total,
    totalPages: Math.max(1, Math.ceil(total / safeLimit)),
  };
}
